import React from 'react';
import LeftBar from '../../Components/LeftBar';
import Dashnav from '../../Components/Dashnav';
import ViewFixedBillComp from './ViewFixedBillComp';

function ViewFixedBill() {
  return (
    <div className="mainContainer">
      <LeftBar />
      <div className="theMainContainer">
        <Dashnav />
        <ViewFixedBillComp />
      </div>
    </div>
  );
}

export default ViewFixedBill;
